<template>
  <card class="no-border-card card-ingredients mb-6" body-classes="p-0">
    <template slot="header">
      <b-row align-v="center">
        <b-col xs="12" md="5">
          <h2></h2>
          <p>SubRecipes</p>
        </b-col>

      </b-row>
    </template>

    <el-table :data="this.subRecipes"
      header-row-class-name="thead-light" 
      row-key="id" 
      class="table-ingredients">

      <el-table-column min-width="385px" prop="name">
        <template v-slot="{ row }">
          <b-media no-body class="align-items-center">
            <div class="avatar mr-3 table__avatar avatar--grey rounded-circle">
              <span v-if="row.name">{{ row.name.charAt(0) }}</span>
            </div>
            <b-media-body class="table__title-wrapper">
              <span class="font-weight-600 name mb-0 text-sm text-capitalize">{{ row.name }}</span>
            </b-media-body>
          </b-media>

          <br/>
          <span style="font-weight:bold">Ingredients:</span>
          <ul id="example-1" style="list-style-type:none;">
            <li v-for="ingredient in row.recipeIngredients" :key="ingredient.id">
              {{ (ingredient.volume ? ingredientAmt(ingredient.volume) : '') + ' ' + (ingredient.grams ? '(' + ingredientAmt(ingredient.grams) + 'g' + ')' : '') + ' ' + (ingredient.unitName ? ingredient.unitName : '') + ' ' + (ingredient.itemCode ? ingredient.itemCode : '') + ' ' + (ingredient.spec ? ingredient.spec : '') + ' ' + (ingredient.prep ? ingredient.prep : '') + ' ' + (ingredient.amount ? ingredient.amount : '') + ' ' + ingredient.ingredientName }}
            </li>
          </ul>

          <span style="font-weight:bold">Instructions:</span>
          <ul id="example-1" style="list-style-type:none;">
            <li v-for="instruction in row.instructions" :key="instruction.id">
              <div v-html="replacedInstructions(instruction)"></div>
            </li>
          </ul>
        </template>
      </el-table-column>

    </el-table>

  </card>
</template>
<script>
  import { Table, TableColumn, Select, Option, DropdownMenu, DropdownItem, Dropdown } from 'element-ui';
  import swal from 'sweetalert2';
  import n2f from 'num2fraction';


  export default {
    name: 'recipe-subrecipes',
    props: ['recipeData'],
    components: {
      [Table.name]: Table,
      [TableColumn.name]: TableColumn,
      [Dropdown.name]: Dropdown,
      [DropdownItem.name]: DropdownItem,
      [DropdownMenu.name]: DropdownMenu
    },
    data() {
      return {
        data: null,
        tableData: [],
        measureSystem: 'us',
        times: 1,
        estimateCost: 0
      }
    },
    computed: {
      subRecipes() {
        return this.$store.state.recipes.subrecipes;
      }
    },
    methods: {
      replacedInstructions(instruction) {
        return instruction.sortOrder + ') ' + instruction.instruction.replace(/<\/?[^>]+(>|$)/g, "")
      },
      ingredientAmt(ingredient){
        if(ingredient == null || ingredient == '') {
          return '';
        }

        if(isNaN(ingredient)){
          return ingredient;
        }

        var decimal = Number((eval(ingredient) * this.times).toFixed(2));
        if (decimal % 1 != 0) {
          var int = Math.trunc(decimal)
          var frac = n2f(decimal - int)
          if (int != 0){
            return int + ' ' + frac
          }
          return frac
        }
        return decimal
      },

      toggleActive(event) {

        const button = event.target;
        button.classList.add('active')

        Array.prototype.filter.call(button.parentNode.children, function(child){
          if (child !== button) {
            child.classList.remove('active')
          }
        });
      },
      showEstimateCost(event) {
        event.preventDefault();

        const button = event.target;

        document.querySelector('.js-btn-estimate').classList.remove('d-none');

        button.classList.add('d-none');
      },
    },
    created(){
      //this.$store.dispatch("recipes/getSubRecipes", this.recipeData.id);
    },
    mounted() {

    },
    watch: {
      $route(to, from) {
        this.onCreated();
      }
    }
  }
</script>
<style></style>
